import { useCallback, useState } from 'react';
import { SelectProps } from '../Select';
import { SelectMenuSelect } from './SelectMenuSelect';

export type SelectMenuSelectProps = Omit<SelectProps, 'open' | 'onOpen' | 'maxHeight'> & {
  initialOpen?: boolean;
};

export function useSelectMenuSelect(props: SelectMenuSelectProps) {
  const { onClose, initialOpen, ...rest } = props;
  const [open, setOpen] = useState(initialOpen ?? false);
  const onOpen = useCallback(() => setOpen(true), []);
  const handleApply = useCallback(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  const handleCancel = useCallback(() => setOpen(false), []);
  const selectProps: SelectProps = {
    open,
    onOpen,
    onClose: handleApply,
    ...rest,
  };
  return {
    selectProps,
    Select: SelectMenuSelect,
    handleApply,
    handleCancel,
  };
}
